import React from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  type ModalProps,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text
} from '@chakra-ui/react'
import { type Activity } from '../activities'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface IntroModalType extends ModalProps {
  activity: Activity
}

const IntroModal: React.FC<IntroModalType> = (props) => {
  const { isOpen, onClose, activity, ...rest } = props
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl" {...rest}>
      <ModalOverlay />
      <ModalContent overflow="auto">
        <ModalHeader>
          <Heading size="xl" mb="0">
            {activity.name}
          </Heading>
          <Text fontWeight="900" mt="0" mb="0px">
            {activity.recommendedSize} People - Version {activity.version}
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px="24px">
          <Heading size="md" mb="20px">
            {activity.description.map((item, index) => (
              <Text as="div" key={index}>
                <Markdown remarkPlugins={[remarkGfm]}>{item}</Markdown>
              </Text>
            ))}
          </Heading>
          <Flex gap="3vw" flexDir={{ base: 'column', md: 'row' }}>
            {activity.hostInfo != null && (
              <Box flexGrow="1">
                <>
                  <Heading
                    size="lg"
                    fontSize="clamp(16px, 2.5vw, 24px)"
                    mb="0.25vw"
                  >
                    Host<br /><sup>Requires Large Screen</sup>
                  </Heading>
                  {activity.hostInfo.map((item, index) => (
                    <Text
                      as="div"
                      fontSize="clamp(16px, 1.5vw, 20px)"
                      key={index}
                    >
                      <Markdown remarkPlugins={[remarkGfm]}>{item}</Markdown>
                    </Text>
                  ))}
                </>
              </Box>
            )}
            {activity.audienceInfo != null && (
              <Box flexGrow="1">
                <>
                  <Heading fontSize="clamp(16px, 2.5vw, 24px)" mb="0.25vw">
                    Audience<br /><sup>Any Device With A Web Browser</sup>
                  </Heading>
                  {activity.audienceInfo?.map((item, index) => (
                    <Text
                      as="div"
                      fontSize="clamp(16px, 1.5vw, 20px)"
                      key={index}
                    >
                      <Markdown remarkPlugins={[remarkGfm]}>{item}</Markdown>
                    </Text>
                  ))}
                </>
              </Box>
            )}
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button variant="outlineNegative" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
export default IntroModal
